import { attr, ProtoBaseModel } from '@square/dashboard-data/utils/ember-model-stubs';
import CatalogObjectReference from '@square/dashboard-items-data/models/invoices/cart/catalog-object-reference';
import { CalculationPhase } from '@square/dashboard-items-data/models/invoices/enums';
import Surcharge from '@square/dashboard-items-data/models/surcharge';
import { CurrencyCode } from '@square/dashboard-protos/models/squareup/common/dinero';
import Enum from '@square/dashboard-utilities/utils/enum';
const {
  SurchargeCalculationType
} = Surcharge;
const AutoEnableType = new Enum(['UNKNOWN', 'MINIMUM_SEAT_COUNT', 'ALWAYS']);
export const Type = new Enum(['UNKNOWN', 'AUTO_GRATUITY', 'CUSTOM']);

// squareup.api.items.Surcharge.AutoGratuitySettings
export const AutoGratuitySettings = ProtoBaseModel.extend({
  autoEnableType: attr(AutoEnableType),
  minumumSeatCount: attr(Number)
});

// squareup.common.dinero.Money
export const Money = ProtoBaseModel.extend({
  cents: attr(Number),
  currencyCode: attr(CurrencyCode)
});

// squareup.api.items.Surcharge
export default ProtoBaseModel.extend({
  amount: attr(Money),
  autoGratuity: attr(AutoGratuitySettings),
  calculationPhase: attr(CalculationPhase),
  calculationType: attr(SurchargeCalculationType, {
    defaultValue: SurchargeCalculationType.FIXED
  }),
  catalogObjectReference: attr(CatalogObjectReference),
  color: attr(String),
  id: attr(String),
  name: attr(String),
  percentage: attr(String),
  taxable: attr(Boolean),
  type: attr(Type)
}).reopenClass({
  // To be used when converting from catalog model
  createFor(surcharge) {
    return this.create({
      amount: surcharge.price ? Money.create({
        cents: surcharge.price?.amount,
        currencyCode: surcharge.price?.currencyCode
      }) : undefined,
      autoGratuity: AutoGratuitySettings.create({
        autoEnableType: surcharge.autoEnableType,
        minimumSeatCount: surcharge.minimumSeatCount
      }),
      calculationPhase: CalculationPhase[surcharge.calculationPhase],
      calculationType: surcharge.surchargeCalculationType,
      catalogObjectReference: CatalogObjectReference.fromCatalogModel(surcharge),
      color: surcharge.color,
      id: surcharge.id,
      name: surcharge.name,
      percentage: surcharge.percentage,
      taxable: surcharge.taxableNonItem,
      type: Type[surcharge.surchargeType],
      ecomApplyToFulfillmentTypes: surcharge.ecomApplyToFulfillmentTypes
    });
  }
});